import React from "react";
import { PageHero } from "@/components/Section";

export default function MentionsLegales() {
  return (
    <div data-testid="mentions-page">
      <PageHero overline="Informations" title="Mentions légales" />
      <section className="max-w-3xl mx-auto px-4 sm:px-6 py-12 sm:py-16 prose prose-slate">
        <h3 className="text-xl font-bold text-slate-900">Éditeur du site</h3>
        <p className="text-slate-600">Le présent site est édité par le mouvement DEFAR - Les Bâtisseurs, dont le siège est situé à Dakar, Sénégal.</p>
        <h3 className="text-xl font-bold text-slate-900 mt-8">Directeur de la publication</h3>
        <p className="text-slate-600">Le Président du mouvement DEFAR - Les Bâtisseurs.</p>
        <h3 className="text-xl font-bold text-slate-900 mt-8">Protection des données</h3>
        <p className="text-slate-600">Les informations recueillies via les formulaires sont destinées exclusivement à la gestion des relations avec les membres et sympathisants du mouvement. Conformément à la réglementation en vigueur, vous disposez d'un droit d'accès, de rectification et de suppression de vos données.</p>
        <h3 className="text-xl font-bold text-slate-900 mt-8">Contact</h3>
        <p className="text-slate-600">Pour toute question : contact@defar.sn</p>
      </section>
    </div>
  );
}
